import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import { deleteSaga } from "src/request/delete";
import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { putSaga } from "src/request/put";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import * as Type from "./type";

export const getAgreementListSaga = createAction(
  "GET_AGREEMENT",
  ({ payload, params }: SagaActionParams<Type.AgreementDto[]>) => ({
    payload,
    url: "/api/admin/adminpolicies" + (params ? params : ""),
  })
);
export const getAgreementDetailsSaga = createAction(
  "GET_AGREEMENT_DETAILS",
  ({ payload, id }: SagaActionParams<Type.AgreementDetailDto>) => ({
    payload,
    url: "/api/admin/adminpolicies/" + id,
  })
);
export const createAgreementSaga = createAction(
  "CREATE_AGREEMENT",
  ({ payload, body }: SagaActionParams<Type.AgreementDto>) => ({
    payload,
    url: "/api/admin/adminpolicies",
    body,
  })
);
export const updateAgreementSaga = createAction(
  "UPDATE_AGREEMENT",
  ({ payload, id, body }: SagaActionParams<Type.AgreementDto>) => ({
    payload,
    url: "/api/admin/adminpolicies/" + id,
    body,
  })
);
export const deleteAgreementSaga = createAction(
  "DELETE_AGREEMENT",
  ({ payload, id }: SagaActionParams<Type.AgreementDto>) => ({
    payload,
    url: "/api/admin/adminpolicies/" + id,
  })
);

const agreementSaga = [
  takeLatest<any>(
    getAgreementListSaga.toString(),
    (payload: SagaGenericParams<Type.AgreementDto[]>) =>
      getSaga<Type.AgreementDto[]>(payload)
  ),
  takeLatest<any>(
    getAgreementDetailsSaga.toString(),
    (payload: SagaGenericParams<Type.AgreementDetailDto>) =>
      getSaga<Type.AgreementDetailDto>(payload)
  ),
  takeLatest<any>(
    createAgreementSaga.toString(),
    (payload: SagaGenericParams<Type.AgreementDto>) =>
      postSaga<Type.AgreementDto>(payload)
  ),
  takeLatest<any>(
    updateAgreementSaga.toString(),
    (payload: SagaGenericParams<Type.AgreementDto>) =>
      putSaga<Type.AgreementDto>(payload)
  ),
  takeLatest<any>(
    deleteAgreementSaga.toString(),
    (payload: SagaGenericParams<any>) => deleteSaga<Type.AgreementDto>(payload)
  ),
];

export default agreementSaga;
